function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 0C5.59667 0 0 5.59667 0 12.5C0 19.4033 5.59667 25 12.5 25C19.4033 25 25 19.4033 25 12.5C25 5.59667 19.4033 0 12.5 0ZM18.1183 18.545H16.4446L16.1908 17.0358C15.7042 17.6075 15.2662 18.0104 14.8783 18.2442C14.2112 18.6521 13.3912 18.8567 12.4179 18.8567C10.8158 18.8567 9.50333 18.3017 8.48125 17.1929C7.41458 16.0779 6.88167 14.5533 6.88167 12.6187C6.88167 10.6625 7.42 9.09417 8.4975 7.91375C9.57458 6.73333 10.9992 6.14333 12.7708 6.14333C14.3075 6.14333 15.5417 6.53292 16.4742 7.31208C17.4067 8.09125 17.9412 9.06333 18.0779 10.2279H15.5925C15.4012 9.4025 14.9333 8.82542 14.1904 8.4975C13.7746 8.31667 13.3125 8.22708 12.8038 8.22708C11.8304 8.22708 11.0308 8.59417 10.4046 9.32833C9.77875 10.0625 9.46542 11.1658 9.46542 12.6392C9.46542 14.1237 9.80458 15.1746 10.4825 15.7912C11.1604 16.4075 11.9317 16.7162 12.7954 16.7162C13.6433 16.7162 14.3375 16.4729 14.8787 15.9867C15.4204 15.5004 15.7537 14.8633 15.8796 14.075H13.0825V12.0571H18.1187V18.545H18.1183Z",
  fill: "url(#paint2_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 0,
  y1: 12.5,
  x2: 25,
  y2: 12.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D78169"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC700"
})));

function SvgGold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.22c25e4b.svg";
export { ForwardRef as ReactComponent };